import { render } from "./CollectionNotify.vue?vue&type=template&id=e8b63222"
import script from "./CollectionNotify.vue?vue&type=script&lang=js"
export * from "./CollectionNotify.vue?vue&type=script&lang=js"

import "./CollectionNotify.vue?vue&type=style&index=0&id=e8b63222&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__